import { COMMON_COMPONENT_PROPS } from '../const';
import { IComponentDefinition } from '../types';

import { Overline } from '@cian/ui-kit';

const overlineComponent: IComponentDefinition = {
  ...COMMON_COMPONENT_PROPS,
  id: 'overline',
  component: Overline,
  tagName: 'overline',
  stylable: true,
  droppable: false,
  defaultAttributes: {
    children: 'Overline',
  },
  traits: [
    {
      type: 'text',
      name: 'children',
      label: 'Текст',
    },
  ],
  block: {
    label: 'Overline',
    category: 'Typography',
    content: '<Overline>Overline</Overline>',
  },
};

export const otherText = {
  Overline: overlineComponent,
};
